import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { payGuide } from "../content/pay-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/pay-calculator"

/** Free pay calculator (T914); the content is a `Guide`, the URL is top level (copy-products.md). */
export const payCalculatorSeo = () => guideSeo(payGuide, PATH)

export const Route = createFileRoute("/_brand-layout/pay-calculator")({
  head: () => {
    const { meta, links, scripts } = payCalculatorSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={payGuide} />,
})
